module.exports = __webpack_public_path__ + "static/media/MV.6ef58642.svg";